import { WindowSize } from "./WindowSize.js";

/**
 * Returns the (browser tab) window size.
 */
export const getWindowSize = (): WindowSize => {
  return {
    width: window.document.body.clientWidth,
    height: window.document.body.clientHeight
  };
};
